import { jsxs, jsx } from "react/jsx-runtime";
import { Text, Tooltip } from "@wix/wix-ui-tpa/cssVars";
import { Flag } from "../flag.js";
import { classes, st } from "./country-option.st.css";
const MAX_CHARS = 25;
function CountryOption({
  callingCode,
  countryName,
  longCountryCode,
  clip = true
}) {
  if (!clip) {
    return /* @__PURE__ */ jsxs("div", { className: classes.root, children: [
      /* @__PURE__ */ jsx("div", { className: classes.flag, children: /* @__PURE__ */ jsx(Flag, { longCountryCode }) }),
      /* @__PURE__ */ jsxs(Text, { className: classes.text, children: [
        countryName,
        /* @__PURE__ */ jsx("span", { "aria-hidden": "true", children: " " }),
        /* @__PURE__ */ jsx("span", { dir: "ltr", lang: "en", children: callingCode })
      ] })
    ] });
  }
  return /* @__PURE__ */ jsxs("div", { className: st(classes.root, { nowrap: clip }), children: [
    /* @__PURE__ */ jsx("div", { className: classes.flag, children: /* @__PURE__ */ jsx(Flag, { longCountryCode }) }),
    /* @__PURE__ */ jsx(Text, { className: classes.text, "aria-label": countryName, children: countryName.length > MAX_CHARS ? /* @__PURE__ */ jsx(Tooltip, { appendTo: "window", showDelay: 300, content: countryName, children: `${countryName.substring(0, MAX_CHARS)}...` }) : countryName }),
    /* @__PURE__ */ jsx(Text, { className: classes.text, "aria-hidden": "true", children: " " }),
    /* @__PURE__ */ jsx(Text, { className: classes.text, children: /* @__PURE__ */ jsx("span", { dir: "ltr", lang: "en", children: callingCode }) })
  ] });
}
export {
  CountryOption
};
//# sourceMappingURL=country-option.js.map
